exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-types__add-button {\n  margin-bottom: 16px;\n  float: right;\n}\n.member-types__member-type-color {\n  height: 32px;\n}\n.member-types__table {\n  clear: both;\n}\n.member-type__duration {\n  text-align: center;\n}\n", ""]);

// exports
